/* eslint-disable consistent-return */
import React, { useState } from 'react';
import { logoutUser } from '../redux/slices/userProfile';
import { useDispatch } from 'react-redux';
import useNoInitialEffect from '../hooks/useDidMountEffect';
import { useIdleTimer } from 'react-idle-timer';
import * as Sentry from '@sentry/browser';

import { Dialog, Box, Typography } from '@mui/material';
import { CustomButton } from '../components/common/Button';

const IdleTimerModal = () => {
  const dispatch = useDispatch();
  const [logoutTimer, setLogoutTimer] = useState(60);
  const [showModal, setShowModal] = useState<boolean>(false);
  const logoutTime = parseInt(process.env.REACT_APP_MODAL_TIMER_MINUTES || '720');

  const { reset } = useIdleTimer({
    timeout: (1000 * 60) * logoutTime,
    onIdle: () => setShowModal(true),
    onActive: () => reset(),
    onAction: () => reset(),
    debounce: 5000,
  });


  useNoInitialEffect(() => {
    if (!showModal) {
      setLogoutTimer(60);
      return;
    }
    if (logoutTimer === 0) {
      dispatch(logoutUser());
      Sentry.setUser(null);
      return;
    }
    const timerId = setTimeout(
      () => setLogoutTimer((count) => (count > 0 ? count - 1 : count)),
      1000,
    );
    return () => clearTimeout(timerId);
  }, [showModal, logoutTimer]);


  return (
    <Dialog
      open={showModal}
      onClose={() => setShowModal(false)}
    >
      <Box sx={{
        bgcolor: 'primary.theme',
        padding: 6,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}>
        <Typography
          sx={{
            color: 'text.primary',
            fontSize: 22,
            marginBottom: 3,
            textAlign: 'center',
          }}
          variant={'h3'}
        >
          You have been idle for over {logoutTime - 1} minutes.
        </Typography>
        <Typography
          sx={{
            color: 'text.primary',
            textAlign: 'center',
            fontSize: 18,
          }}
        >
          Due to incativity
        </Typography>
        <Typography
          mb={6}
          sx={{
            color: 'text.primary',
            textAlign: 'center',
            fontSize: 18,
          }}
        >
          You will be logged out in {logoutTimer} seconds.
        </Typography>
        <CustomButton
          bgcolor={'primary'}
          sx={{
            color: 'grey.100',
          }}
          onClick={() => setShowModal(false)}
        >
          Click here to renew session
        </CustomButton>
      </Box>
    </Dialog>
  );
};

export default IdleTimerModal;
